import { instance } from "libs/api";

import { ApiRoutesTransfers } from "../../constants";
import { Transfer } from "../../transfers.types";

export interface CancelTransferPayload {
  transferId: string;
  note?: string;
}

export const requestCancelTransfer = async ({
  transferId,
  note,
}: CancelTransferPayload): Promise<Transfer> => {
  return await instance.post(
    `${ApiRoutesTransfers.Transfers}/${transferId}/cancel`,
    { note },
  );
};
